import { render, staticRenderFns } from "./KCCreateComponent.vue?vue&type=template&id=865509ce&"
import script from "./KCCreateComponent.vue?vue&type=script&lang=js&"
export * from "./KCCreateComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports